import { Smiley } from '@phosphor-icons/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { addPercentSign } from './helpers'
import AnalyticsBlock from './AnalyticsBlock'

const SatisfactionSurveyAnalytics = ({ sentSurveys, responses, responseRate }) => {
  const { t } = useTranslation(['surveys'])
  return (
    <div className="ctp-survey__analytics-item">
      <div className="ctp-survey__analytics-header">
        <Smiley size={20} /> {t('surveys:analytics.satisfactionSurveys')}
      </div>
      <div className="ctp-survey__analytics-row">
        <AnalyticsBlock
          subtitle={t('surveys:analytics.sent')}
          title={sentSurveys.total}
          faces={sentSurveys.subtype.smiley}
          thumbs={sentSurveys.subtype.thumbs}
          stars={sentSurveys.subtype.stars}
        />
        <AnalyticsBlock
          subtitle={t('surveys:analytics.responses')}
          title={responses.total}
          faces={responses.subtype.smiley}
          thumbs={responses.subtype.thumbs}
          stars={responses.subtype.stars}
        />
        <AnalyticsBlock
          subtitle={t('surveys:analytics.responsesRate')}
          title={addPercentSign(responseRate.total)}
          faces={addPercentSign(responseRate.subtype.smiley)}
          thumbs={addPercentSign(responseRate.subtype.thumbs)}
          stars={addPercentSign(responseRate.subtype.stars)}
        />
      </div>
    </div>
  )
}

SatisfactionSurveyAnalytics.propTypes = {
  sentSurveys: PropTypes.number,
  responses: PropTypes.number,
  responseRate: PropTypes.string,
}

export default SatisfactionSurveyAnalytics
